module.exports = __webpack_public_path__ + "img/justins-low-fat-french-toast.f7d29e12.jpg";